/**
 * PostHog module - All analytics removed
 * These are no-op stubs to maintain API compatibility
 */

export const POSTHOG_ENABLED = false

export const waitForPosthog = async () => false

export const initializePostHog = async () => {}

export const setPostHogPersonMetadata = async () => {}

export const resetPostHog = () => {}

export const hasOptedOutCapturing = () => true

export const capturePostHogEvent = () => {}

export const isFeatureFlagEnabled = async () => false

export const getFeatureFlag = async () => undefined

export const getFeatureFlagPayload = async () => undefined

export const startPosthogSessionRecording = async () => {}

export const stopPosthogSessionRecording = () => {}
